import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  Grid,
  Chip,
  Divider
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';

const SearchResults = ({ results, onSelectAfiliado }) => {
  if (!results || results.length === 0) {
    return null;
  }

  const handleSelectAfiliado = (afiliado) => {
    onSelectAfiliado(afiliado.dni);
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PersonIcon />
        Resultados de búsqueda ({results.length})
      </Typography>
      
      <Grid container spacing={2}>
        {results.map((afiliado, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card 
              elevation={2} 
              sx={{ 
                height: '100%',
                '&:hover': { 
                  elevation: 4,
                  transform: 'translateY(-2px)',
                  transition: 'all 0.2s ease-in-out'
                },
                borderLeft: afiliado.id_estado === 'B' ? '4px solid #f44336' : '4px solid transparent'
              }}
            >
              <CardActionArea 
                onClick={() => handleSelectAfiliado(afiliado)}
                sx={{ height: '100%', p: 0 }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    {afiliado.es_titular ? (
                      <PersonIcon color="primary" />
                    ) : (
                      <FamilyRestroomIcon color="secondary" />
                    )}
                    <Chip 
                      label={afiliado.es_titular ? 'Titular' : 'Familiar'} 
                      size="small"
                      color={afiliado.es_titular ? 'primary' : 'secondary'}
                      variant="outlined"
                    />
                    {afiliado.id_estado === 'B' && (
                      <Chip 
                        label={`NO ACTIVO - Baja: ${afiliado.fecbaja || 'Fecha no disponible'}`} 
                        size="small" 
                        color="error" 
                        variant="outlined"
                        sx={{ height: '20px', fontSize: '0.7rem' }}
                      />
                    )}
                  </Box>
                  
                  <Typography variant="h6" component="h3" gutterBottom sx={{ color: afiliado.id_estado === 'B' ? '#f44336' : 'inherit' }}>
                    {afiliado.nombre}
                  </Typography>
                  
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    <strong>DNI:</strong> {afiliado.dni}
                  </Typography>
                  
                  {afiliado.edad && (
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      <strong>Edad:</strong> {afiliado.edad} años
                    </Typography>
                  )}
                  
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    <strong>Categoría:</strong> {afiliado.categoria}
                  </Typography>
                  
                  {afiliado.plan && (
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      <strong>Plan:</strong> {afiliado.plan}
                    </Typography>
                  )}
                  
                  {!afiliado.es_titular && afiliado.nombre_titular && (
                    <>
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="body2" color="text.secondary">
                        <strong>Titular:</strong> {afiliado.nombre_titular}
                      </Typography>
                    </>
                  )}
                  
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    <strong>Afiliación:</strong> {afiliado.fecha_afiliacion}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
        Haga clic en cualquier afiliado para ver su información completa
      </Typography>
    </Box>
  );
};

export default SearchResults;
